/**
 * BillingWalletApi
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { MerchantWalletTransaction } from '../model/merchantWalletTransaction';
import { MerchantWalletTransactionPaginatedResult } from '../model/merchantWalletTransactionPaginatedResult';
import { ProblemDetails } from '../model/problemDetails';
import { Reason } from '../model/reason';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class MerchantWalletTransactionService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param merchantWalletId 
     * @param startDate 
     * @param endDate 
     * @param page 
     * @param pageSize 
     * @param reason 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiMerchantWalletTransactionGet(merchantWalletId?: string, startDate?: Date, endDate?: Date, page?: number, pageSize?: number, reason?: Reason, observe?: 'body', reportProgress?: boolean): Observable<MerchantWalletTransactionPaginatedResult>;
    public apiMerchantWalletTransactionGet(merchantWalletId?: string, startDate?: Date, endDate?: Date, page?: number, pageSize?: number, reason?: Reason, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MerchantWalletTransactionPaginatedResult>>;
    public apiMerchantWalletTransactionGet(merchantWalletId?: string, startDate?: Date, endDate?: Date, page?: number, pageSize?: number, reason?: Reason, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MerchantWalletTransactionPaginatedResult>>;
    public apiMerchantWalletTransactionGet(merchantWalletId?: string, startDate?: Date, endDate?: Date, page?: number, pageSize?: number, reason?: Reason, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {







        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (merchantWalletId !== undefined && merchantWalletId !== null) {
            queryParameters = queryParameters.set('merchantWalletId', <any>merchantWalletId);
        }
        if (startDate !== undefined && startDate !== null) {
            queryParameters = queryParameters.set('startDate', <any>startDate.toISOString());
        }
        if (endDate !== undefined && endDate !== null) {
            queryParameters = queryParameters.set('endDate', <any>endDate.toISOString());
        }
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (pageSize !== undefined && pageSize !== null) {
            queryParameters = queryParameters.set('pageSize', <any>pageSize);
        }
        if (reason !== undefined && reason !== null) {
            queryParameters = queryParameters.set('reason', <any>reason);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<MerchantWalletTransactionPaginatedResult>('get',`${this.basePath}/api/MerchantWalletTransaction`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param merchantAuthId 
     * @param startDate 
     * @param endDate 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiMerchantWalletTransactionGetByMerchantAuthIdMerchantAuthIdGet(merchantAuthId: string, startDate?: Date, endDate?: Date, observe?: 'body', reportProgress?: boolean): Observable<Array<MerchantWalletTransaction>>;
    public apiMerchantWalletTransactionGetByMerchantAuthIdMerchantAuthIdGet(merchantAuthId: string, startDate?: Date, endDate?: Date, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<MerchantWalletTransaction>>>;
    public apiMerchantWalletTransactionGetByMerchantAuthIdMerchantAuthIdGet(merchantAuthId: string, startDate?: Date, endDate?: Date, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<MerchantWalletTransaction>>>;
    public apiMerchantWalletTransactionGetByMerchantAuthIdMerchantAuthIdGet(merchantAuthId: string, startDate?: Date, endDate?: Date, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (merchantAuthId === null || merchantAuthId === undefined) {
            throw new Error('Required parameter merchantAuthId was null or undefined when calling apiMerchantWalletTransactionGetByMerchantAuthIdMerchantAuthIdGet.');
        }



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (startDate !== undefined && startDate !== null) {
            queryParameters = queryParameters.set('startDate', <any>startDate.toISOString());
        }
        if (endDate !== undefined && endDate !== null) {
            queryParameters = queryParameters.set('endDate', <any>endDate.toISOString());
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<MerchantWalletTransaction>>('get',`${this.basePath}/api/MerchantWalletTransaction/GetByMerchantAuthId/${encodeURIComponent(String(merchantAuthId))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
